import { render, staticRenderFns } from "./PollResult.vue?vue&type=template&id=a48795a4&"
import script from "./PollResult.vue?vue&type=script&lang=ts&"
export * from "./PollResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports